export const hosts = {
  API_BASE: 'https://portalcal.navibus.com.ve',
  API_BASE_OFFLINE: 'http://navoffline.api',
  PORT_NAV: '24165',
  PORT_NAV_OFFLINE: ''
};
  
export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  offline: false,

  //Security
  API_BASE_URL_NAV_AUTHENTICATION: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-sec-authe`,
  API_BASE_URL_NAV_AUTHORIZATION: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-sec-autho`,

  //Security offline
  API_BASE_OFFLINE_URL_NAV_AUTHENTICATION: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
  API_BASE_OFFLINE_URL_NAV_AUTHORIZATION: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,

  //Shipping
  API_BASE_URL_NAV_MASTERS: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-masters`,
  API_BASE_URL_NAV_OPERATION: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-operation`,
  API_BASE_URL_NAV_BOXOFFICE: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-boxoffice`,
  API_BASE_URL_NAV_CLIENTCORP: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-clientcorp`,
  API_BASE_URL_NAV_ERPINTEGRATION: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-erpintegration`,
  API_BASE_URL_NAV_MOBILE: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-mobile`,
  API_BASE_URL_NAV_REPORTS: `${hosts.API_BASE}:${hosts.PORT_NAV}/nav-reports`,

  //Shipping offline
  API_BASE_OFFLINE_URL_NAV_MASTERS: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
  API_BASE_OFFLINE_URL_NAV_OPERATION: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
  API_BASE_OFFLINE_URL_NAV_BOXOFFICE: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
  API_BASE_OFFLINE_URL_NAV_CLIENTCORP: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
  API_BASE_OFFLINE_URL_NAV_ERPINTEGRATION: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
  API_BASE_OFFLINE_URL_NAV_MOBILE: `${hosts.API_BASE_OFFLINE}:${hosts.PORT_NAV_OFFLINE}`,
};

export const BNC = {
  AFFILIATION_NUMBER_VPOS: 860112192,
  TERMINAL_C2P: '15015840',
};